import { render } from "./Index.vue?vue&type=template&id=043899bc"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=043899bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/front/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "043899bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('043899bc', __exports__)) {
    api.reload('043899bc', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=043899bc", () => {
    api.rerender('043899bc', render)
  })

}


export default __exports__